import { render, staticRenderFns } from "./ListForm.vue?vue&type=template&id=230c15ee&scoped=true&"
import script from "./ListForm.vue?vue&type=script&lang=js&"
export * from "./ListForm.vue?vue&type=script&lang=js&"
import style0 from "./ListForm.vue?vue&type=style&index=0&id=230c15ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230c15ee",
  null
  
)

export default component.exports